"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailMessage = void 0;

var EmailMessage =
/** @class */
function () {
  function EmailMessage() {}

  EmailMessage.prototype.EmailArchiveCategoryType = function () {
    return [{
      slug: 'alert',
      name: 'Alert',
      description: 'Arrival Alert',
      isAlert: true,
      isInvitation: false,
      isReceipts: false,
      isForgotPassword: false,
      isChangePassword: false,
      isTransferAuthorization: false,
      isTransferConfirmation: false,
      isEventMessage: false,
      isEventMessagePreview: false,
      isReportNotification: false,
      isAccount: false,
      isVerify: false,
      isSystem: false
    }, {
      slug: 'invitation',
      name: 'Invitation',
      description: 'Invitation',
      isAlert: false,
      isInvitation: true,
      isReceipts: false,
      isForgotPassword: false,
      isChangePassword: false,
      isTransferAuthorization: false,
      isTransferConfirmation: false,
      isEventMessage: false,
      isEventMessagePreview: false,
      isReportNotification: false,
      isAccount: false,
      isVerify: false,
      isSystem: false
    }, {
      slug: 'receipts',
      name: 'Receipts',
      description: 'Receipts',
      isAlert: false,
      isInvitation: false,
      isReceipts: true,
      isForgotPassword: false,
      isChangePassword: false,
      isTransferAuthorization: false,
      isTransferConfirmation: false,
      isEventMessage: false,
      isEventMessagePreview: false,
      isReportNotification: false,
      isAccount: false,
      isVerify: false,
      isSystem: false
    }, {
      slug: 'forgotpassword',
      name: 'Forgot Password',
      description: 'Forgot Password',
      isAlert: false,
      isInvitation: false,
      isReceipts: false,
      isForgotPassword: true,
      isChangePassword: false,
      isTransferAuthorization: false,
      isTransferConfirmation: false,
      isEventMessage: false,
      isEventMessagePreview: false,
      isReportNotification: false,
      isAccount: false,
      isVerify: false,
      isSystem: false
    }, {
      slug: 'changepassword',
      name: 'Change Password',
      description: 'Change Password',
      isAlert: false,
      isInvitation: false,
      isReceipts: false,
      isForgotPassword: false,
      isChangePassword: true,
      isTransferAuthorization: false,
      isTransferConfirmation: false,
      isEventMessage: false,
      isEventMessagePreview: false,
      isReportNotification: false,
      isAccount: false,
      isVerify: false,
      isSystem: false
    }, {
      slug: 'transferauthorization',
      name: 'Transfer Authorization',
      description: 'Transfer Authorization',
      isAlert: false,
      isInvitation: false,
      isReceipts: false,
      isForgotPassword: false,
      isChangePassword: false,
      isTransferAuthorization: true,
      isTransferConfirmation: false,
      isEventMessage: false,
      isEventMessagePreview: false,
      isReportNotification: false,
      isAccount: false,
      isVerify: false,
      isSystem: false
    }, {
      slug: 'transferconfirmation',
      name: 'Transfer Confirmation',
      description: 'Transfer Authorization',
      isAlert: false,
      isInvitation: false,
      isReceipts: false,
      isForgotPassword: false,
      isChangePassword: false,
      isTransferAuthorization: false,
      isTransferConfirmation: true,
      isEventMessage: false,
      isEventMessagePreview: false,
      isReportNotification: false,
      isAccount: false,
      isVerify: false,
      isSystem: false
    }, {
      slug: 'eventmessage',
      name: 'Event Message',
      description: 'Event Message',
      isAlert: false,
      isInvitation: false,
      isReceipts: false,
      isForgotPassword: false,
      isChangePassword: false,
      isTransferAuthorization: false,
      isTransferConfirmation: false,
      isEventMessage: true,
      isEventMessagePreview: false,
      isReportNotification: false,
      isAccount: false,
      isVerify: false,
      isSystem: false
    }, {
      slug: 'eventmessagepreview',
      name: 'Event Message Preview',
      description: 'Event Message Preview',
      isAlert: false,
      isInvitation: false,
      isReceipts: false,
      isForgotPassword: false,
      isChangePassword: false,
      isTransferAuthorization: false,
      isTransferConfirmation: false,
      isEventMessage: false,
      isEventMessagePreview: true,
      isReportNotification: false,
      isAccount: false,
      isVerify: false,
      isSystem: false
    }, {
      slug: 'reportnotification',
      name: 'Report Notification',
      description: 'Report Notification',
      isAlert: false,
      isInvitation: false,
      isReceipts: false,
      isForgotPassword: false,
      isChangePassword: false,
      isTransferAuthorization: false,
      isTransferConfirmation: false,
      isEventMessage: false,
      isEventMessagePreview: false,
      isReportNotification: true,
      isAccount: false,
      isVerify: false,
      isSystem: false
    }, {
      slug: 'account',
      name: 'Account',
      description: 'Account',
      isAlert: false,
      isInvitation: false,
      isReceipts: false,
      isForgotPassword: false,
      isChangePassword: false,
      isTransferAuthorization: false,
      isTransferConfirmation: false,
      isEventMessage: false,
      isEventMessagePreview: false,
      isReportNotification: false,
      isAccount: true,
      isVerify: false,
      isSystem: false
    }, {
      slug: 'verify',
      name: 'verify',
      description: 'Verify',
      isAlert: false,
      isInvitation: false,
      isReceipts: false,
      isForgotPassword: false,
      isChangePassword: false,
      isTransferAuthorization: false,
      isTransferConfirmation: false,
      isEventMessage: false,
      isEventMessagePreview: false,
      isReportNotification: false,
      isAccount: false,
      isVerify: true,
      isSystem: false
    }, {
      slug: 'system',
      name: 'System',
      description: 'System',
      isAlert: false,
      isInvitation: false,
      isReceipts: false,
      isForgotPassword: false,
      isChangePassword: false,
      isTransferAuthorization: false,
      isTransferConfirmation: false,
      isEventMessage: false,
      isEventMessagePreview: false,
      isReportNotification: false,
      isAccount: false,
      isVerify: false,
      isSystem: true
    }];
  };

  EmailMessage.prototype.EmailArchiveSubCategoryType = function () {
    return [{
      slug: 'ticketblock',
      name: 'Ticket Block',
      description: null,
      isTicketBlock: true,
      isGroup: false,
      isEventCheckedIn: false,
      isTicketType: false,
      isPreview: false,
      isNoShow: false,
      isWaitList: false,
      isNone: false,
      isExhibitor: false
    }, {
      slug: 'group',
      name: 'Group',
      description: null,
      isTicketBlock: false,
      isGroup: true,
      isEventCheckedIn: false,
      isTicketType: false,
      isPreview: false,
      isNoShow: false,
      isWaitList: false,
      isNone: false,
      isExhibitor: false
    }, {
      slug: 'eventcheckedin',
      name: 'Event Checked-In',
      description: null,
      isTicketBlock: false,
      isGroup: false,
      isEventCheckedIn: true,
      isTicketType: false,
      isPreview: false,
      isNoShow: false,
      isWaitList: false,
      isNone: false,
      isExhibitor: false
    }, {
      slug: 'tickettype',
      name: 'Ticket Type',
      description: null,
      isTicketBlock: false,
      isGroup: false,
      isEventCheckedIn: false,
      isTicketType: true,
      isPreview: false,
      isNoShow: false,
      isWaitList: false,
      isNone: false,
      isExhibitor: false
    }, {
      slug: 'preview',
      name: 'Preview',
      description: null,
      isTicketBlock: false,
      isGroup: false,
      isEventCheckedIn: false,
      isTicketType: false,
      isPreview: true,
      isNoShow: false,
      isWaitList: false,
      isNone: false,
      isExhibitor: false
    }, {
      slug: 'noshow',
      name: 'No-Show',
      description: null,
      isTicketBlock: false,
      isGroup: false,
      isEventCheckedIn: false,
      isTicketType: false,
      isPreview: false,
      isNoShow: true,
      isWaitList: false,
      isNone: false,
      isExhibitor: false
    }, {
      slug: 'waitlist',
      name: 'Wait List',
      description: null,
      isTicketBlock: false,
      isGroup: false,
      isEventCheckedIn: false,
      isTicketType: false,
      isPreview: false,
      isNoShow: false,
      isWaitList: true,
      isNone: false,
      isExhibitor: false
    }, {
      slug: 'None',
      name: 'None',
      description: null,
      isTicketBlock: false,
      isGroup: false,
      isEventCheckedIn: false,
      isTicketType: false,
      isPreview: false,
      isNoShow: false,
      isWaitList: false,
      isNone: true,
      isExhibitor: false
    }, {
      slug: 'exhibitor',
      name: 'Exhibitor',
      description: null,
      isTicketBlock: false,
      isGroup: false,
      isEventCheckedIn: false,
      isTicketType: false,
      isPreview: false,
      isNoShow: false,
      isWaitList: false,
      isNone: false,
      isExhibitor: true
    }];
  };

  EmailMessage.prototype.EmailMessageType = function () {
    return [{
      slug: 'confirmation',
      name: 'Confirmation',
      description: 'Confirmation Message Type',
      isConfirmation: true,
      isDonation: false,
      isInvitation: false,
      isSendAMessage: false,
      isSendGroupMessage: false,
      isDeclination: false,
      isSendPreviewMessage: false
    }, {
      slug: 'donation',
      name: 'Donation',
      description: 'Donation Message Type',
      isConfirmation: false,
      isDonation: true,
      isInvitation: false,
      isSendAMessage: false,
      isSendGroupMessage: false,
      isDeclination: false,
      isSendPreviewMessage: false
    }, {
      slug: 'invitation',
      name: 'Invitation',
      description: 'Invitation Message Type',
      isConfirmation: false,
      isDonation: false,
      isInvitation: true,
      isSendAMessage: false,
      isSendGroupMessage: false,
      isDeclination: false,
      isSendPreviewMessage: false
    }, {
      slug: 'sendamessage',
      name: 'Send A Message',
      description: 'Send A Message Type',
      isConfirmation: false,
      isDonation: false,
      isInvitation: false,
      isSendAMessage: true,
      isSendGroupMessage: false,
      isDeclination: false,
      isSendPreviewMessage: false
    }, {
      slug: 'sendgroupmessage',
      name: 'Send Group Message',
      description: 'Send Group Message Type',
      isConfirmation: false,
      isDonation: false,
      isInvitation: false,
      isSendAMessage: false,
      isSendGroupMessage: true,
      isDeclination: false,
      isSendPreviewMessage: false
    }];
  };

  return EmailMessage;
}();

exports.EmailMessage = EmailMessage;